import React from 'react';
import Input from '../../../components/ui/Input';

import Icon from '../../../components/AppIcon';

const DailyMessageEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Günlük Mesaj İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Instagram Stories'de paylaşılabilir mesaj oluşturun
          </p>
        </div>
      </div>
      <Input
        label="Mesaj Başlığı"
        type="text"
        placeholder="Örn: Güvenli Yolculuklar!"
        value={content?.title || ''}
        onChange={(e) => handleChange('title', e?.target?.value)}
        required
        description="Kullanıcılara gösterilecek ana başlık"
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Mesaj İçeriği
          <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          className="flex w-full rounded-lg border border-input bg-input px-4 py-3 text-sm focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring focus-visible:ring-offset-3 disabled:cursor-not-allowed disabled:opacity-50 min-h-32 md:min-h-40"
          placeholder="Bugünün mesajını buraya yazın..."
          value={content?.message || ''}
          onChange={(e) => handleChange('message', e?.target?.value)}
          required
        />
        <p className="caption text-muted-foreground mt-2">
          Trafik güvenliği, motivasyon veya bilgilendirme içerikli mesaj yazın
        </p>
      </div>
      <div className="p-4 md:p-6 rounded-lg bg-accent/10 border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Instagram Stories Paylaşımı
            </p>
            <p className="caption text-muted-foreground">
              Kullanıcılar bu mesajı Instagram Stories'de paylaşabilecek. Mesajınızın görsel olarak çekici olmasına dikkat edin.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyMessageEditor;